import { Button } from 'components/buttons';
import styled from 'styled-components';

export const ActionsRow = styled.div.attrs({
  className: 'flex items-center justify-between w-full gap-2',
})``;

export const SecondaryActions = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

const ActionButton = styled(Button).attrs({
  size: 'xs',
  className: 'px-2 has-[>svg]:px-2 gap-1',
})``;

export const DiscardButton = styled(ActionButton).attrs({
  variant: 'ghost',
  className:
    'bg-destructive/10 text-destructive hover:bg-destructive/20 hover:text-destructive dark:bg-destructive/20',
})``;

export const EndAndTranscribeButton = styled(ActionButton).attrs({
  variant: 'secondary',
})``;

export const ResumeButton = styled(ActionButton).attrs({
  variant: 'default',
})``;
